import { View } from "binder"
import { MachineManipulationViewModel, Machine } from "./machineManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class MachineManipulationView extends View<MachineManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-4F885066-7323-4436-B170-D4AE52D38E52"
    }
    loadHtml(): string {
        let element = require('./machineManipulation.html').default;
        let style = require('./machineManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set machines(v: Machine) { this._machines = v; } public get machines(): Machine { return this._machines; } private _machines: Machine;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
